export enum EYmEvents {
	PAGE_VIEW = 'page_view',
	CLICK_START = 'click_start',
	CLICK_NEXT = 'click_next',
	CLICK_ADD_ADSPACE = 'click_add_adspace',
	SEND_ADD_ADSPACE_SUCCESS = 'send_add_adspace_success',
	CLICK_SKIP_ADD_ADSPACE = 'click_skip_add_adspace',
	CLICK_VERIFY_ADSPACE = 'click_verify_adspace',
	CLICK_SLIP_VERIFY_ADSPACE = 'click_skip_verify_adspace',
	CLICK_SEND_TO_WALLET = 'click_send_to_wallet',
	CLICK_GO_TO_WALLET = 'click_go_to_wallet',
	CLICK_GO_TO_STATISTIC = 'click_go_to_statistic',
	CLICK_FILTER = 'click_filter',
	CLICK_JOIN = 'click_join',
	CLICK_SEND_JOIN = 'click_send_join',
	SEND_JOIN_SUCCESS = 'send_join_success',
	CLICK_MENU_ADSPACE = 'click_menu_adspace',
	CLICK_EDIT_ADSPACE = 'click_edit_adspace',
	CLICK_DETAILS_ADSPACE = 'click_details_adspace',
	CLICK_DELETE_ADSPACE = 'click_delete_adspace',
	ERROR_BLACKLIST_ADSPACE = 'error_blacklist_adspace',
	CLICK_CONNENCT_TELEGRAM_BOT = 'click_connect_telegram_bot',
	CLICK_VIEW_INSTRUCTION = 'click_view_instruction',
	CLICK_COPY_LINK_TOKEN = 'click_copy_link_token',
	CLICK_EDIT_POSTBACK = 'click_edit_postback',
	CLICK_DELETE_POSTBACK = 'click_delete_postback',
	SEND_ADD_POSTBACK_SUCCESS = 'send_add_postback_success',
	CLICK_COPY_LINK = 'click_copy_link',
	CLICK_ADD_SUBID = 'click_add_subid',
	CLICK_COPY_SHORTLINK = 'click_copy_shortlink',
	SEND_REGISTRATION_SUCCESS = 'send_registration_success',
	CLICK_INSTRUMENT = 'click_instrument',
	VIEW_DASHBOARD_INFO = 'view_dashboard_info',
	VIEW_AFFILEAD_RECCOMENDS = 'view_affilead_reccomends',
	VIEW_BEST_OFFERS = 'view_best_offers',
	VIEW_NOTIFICATIONS_BELL_ICON = 'view_notifications_bell_icon',
}

export enum EYmEventsO1 {
	ACCOUNT = 'account',
	PUBLISHER = 'publisher',
	WELCOME_POPUP = 'welcome popup',
	FINANCE = 'finance',
	CATALOG = 'catalog',
	DASHBOARD = 'dashboard',
	ADSPACE = 'adspace',
	INSTRUMENTS = 'instruments',
	LINKS = 'links',
}

export enum EYmEventsO2 {
	WELCOME = 'welcome',
	ADD_SOCIAL_ACCOUNT = 'add social account',
	ADD_ADSPACE = 'add adspace',
	FINANCE = 'finance',
	BALANCE_HISTORY = 'balance history',
	HEADER = 'header',
	NO_ADSPACES_POPUP = 'no adspaces popup',
	FILTER = 'filter',
	CATALOG = 'catalog',
	JOIN = 'join',
	PROGRAM_DETAILS = 'program details',
	RECOMENDATIONS = 'recommendations',
	BEST_OFFERS = 'best offers for 7 days',
	ADSPACE = 'adspace',
	MENU = 'menu',
	VERIFY = 'verify',
	TELEGRAM_BOT = 'telegram bot',
	API = 'api',
	POSTBACK = 'postback',
	ADD_POSTBACK = 'add postback',
	LINKS = 'links',
	ADD_SUBID = 'add subid',
	REGISTRATION = "registration'",
	INSTRUMENTS_LIST = 'instrument list',
	DASHBOARD = 'dashboard',
}

export enum EYmEventsO4 {
	TELEGRAM = 'telegram',
	ADSPACE = 'adspace',
	ADVERTISER = 'advertiser',
	CATEGORY = 'category',
	TRAFFIK_TYPE = 'traffic type',
	TAGS = 'tags',
	UPDATE_STATISTIC = 'update statistic',
	SUBMITTED_APPLICATIONS = 'submitted applications',
	HEADER = 'header',
	BOTTOM = 'bottom',
	PUBLISHER = 'publisher',
}

export enum EYmEventsGoals {
	SEND_REGISTRATION_SUCCESS_PUBLISHER = 'send_registration_success_publisher',
}
